import { Link, Typography } from "@mui/material";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://suelware.com/">
        Suelware Inc.
      </Link>
      {" 2018-"}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default Copyright;
